export default {"src":"/_next/static/media/eye.2fbf8b86.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};